import { LoginLink } from '../Login/types';
import localLoginLinks from './identity-links.json';
export const defaultLoginLinks: LoginLink[] = localLoginLinks as LoginLink[];
